import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";

export const BLANK_REQUEST = {
  name: "", email: "", phone: "", destination: "", start_date: "", end_date: "", travellers: "", occasion: "",
  interests: "", fixed: "", pace: "", budget: "", accommodation: "", must_do: "", avoid: "", dietary: "", notes: "", website: "",
};

const FIELDS = [
  ["name", "Your name", "input", true], ["email", "Email", "email", true], ["phone", "Phone (optional)", "input"],
  ["destination", "Where would you like to go?", "input", true, "e.g. Kyoto, Japan"],
  ["start_date", "Arriving", "date", true], ["end_date", "Leaving", "date", true],
  ["travellers", "Who is travelling?", "input", false, "e.g. Couple in our 50s, or family with two teens"],
  ["occasion", "Any occasion?", "input", false, "Anniversary, milestone birthday, honeymoon…"],
  ["pace", "Preferred pace", "input", false, "Relaxed, balanced or full days"],
  ["budget", "Budget", "input", false, "e.g. Luxury, around $1,000 AUD a night"],
  ["accommodation", "Accommodation style", "input", false, "Boutique, resort, ryokan, villa…"],
  ["interests", "What do you love?", "area", false, "Food, wine, gardens, hiking, art, wellness…"],
  ["fixed", "Fixed dates or events to work around", "area", false, "e.g. Wedding on 4 April at 3pm, concert tickets 6 April evening, flight lands 2 April 9pm"],
  ["must_do", "Must-dos", "area", false, "Anything you already know you want"],
  ["avoid", "Things to avoid", "area", false, "Crowds, early starts, long drives…"],
  ["dietary", "Dietary or access needs", "input"],
  ["notes", "Anything else?", "area"],
];

const ADMIN = { name: "Customer name", email: "Customer email", destination: "Destination", travellers: "Travellers", occasion: "Occasion", pace: "Pace",
  budget: "Budget", accommodation: "Accommodation", interests: "Interests", must_do: "Must-dos", avoid: "Avoid", notes: "Notes" };

export const RequestFields = ({ value, onChange, emailOptional = false }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="grid md:grid-cols-2 gap-4">
      {FIELDS.map(([k, label, type, req, ph]) => (
        <label key={k} className={`block ${type === "area" || k === "destination" ? "md:col-span-2" : ""}`}>
          <span className="block text-xs uppercase tracking-[0.14em] text-stone-500 mb-1.5">{(emailOptional && ADMIN[k]) || label}{req && !(emailOptional && k === "email") ? " *" : ""}</span>
          {type === "area"
            ? <Textarea data-testid={`request-${k}`} rows={3} placeholder={ph} value={value[k]} onChange={set(k)} className="bg-white" />
            : <Input data-testid={`request-${k}`} type={type === "input" ? "text" : type} required={req && !(emailOptional && k === "email")} placeholder={ph} value={value[k]} onChange={set(k)} className="h-11 bg-white" />}
        </label>
      ))}
      <input tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={value.website} onChange={set("website")} />
    </div>
  );
};
